import { SVGProps, Ref, forwardRef } from 'react';

export const FolderFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.37 2c-5.25 0-7 1.75-7 7v.022C2.708 8.564 4.162 8.5 5.564 8.5h12.872c1.365 0 2.776.063 4.085.486C22.068 5.292 20.14 4 15.63 4H12.3l-.8-2zm14.26 8.975c-.897-.479-2.266-.675-4.194-.675H5.564c-1.929 0-3.297.196-4.194.675-1.473.786-1.676 2.333-1 5.025 1.086 4.332 2.806 6 7.9 6h7.46c5.093 0 6.813-1.668 7.9-6 .675-2.692.472-4.24-1-5.025"
                fill="currentColor"
            />
        </g>
    </svg>
));
FolderFilledSize24Glyph.displayName = 'FolderFilledSize24Glyph';
